import { closeProjectEditorModal } from '../State/projectEditorModal'
import fetch from '../Services/fetch'

export default (reload = false) => (dispatch) => {

  dispatch(closeProjectEditorModal())

  if (reload) {
    dispatch(fetch())
  }

}
